import api from "./common";
import axios from "axios";
import {
  onReqFulfilled,
  onReqRejected,
  onResFulfilled,
  onResRejected,
} from "./helpers";
import { ApiResponse } from "@/types/api.types";
import { Student } from "@/types/user.types";
import { Assignment, AssignmentSubmission } from "@/types/assignments.types";
import { SubjectStats } from "@/types/subject.types";

const studentAPI = axios.create({
  baseURL: process.env.REACT_APP_OLD_API_BASEURL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

studentAPI.interceptors.request.use(onReqFulfilled, onReqRejected);
studentAPI.interceptors.response.use(onResFulfilled, onResRejected);

export const addSingleStudent = async (data) => api.post("/", { action: "register_student", ...data });

export const addBulkStudents = async (data): Promise<ApiResponse> => api.post("/", { action: "bulk_register_student", ...data });

export const getStudents = async (params): Promise<ApiResponse<Student[]>> => api.get("/", { params: { action: "get_session_class_students", ...params } });

export const editStudent = async (data) => api.post(`/`, { action: "update_student", ...data });

export const disableStudentAccount = async (id: string): Promise<ApiResponse<null>> => api.patch(`/users/students/${id}/disable`);

export const enableStudentAccount = async (id: string): Promise<ApiResponse<null>> => api.patch(`/users/students/${id}/enable`);

export const getAssignmentSubmission = (params): Promise<ApiResponse<AssignmentSubmission>> => studentAPI.get("/", { params: { action: "get_assignment_submission", ...params } })

export const getStudentAssignments = (params): Promise<ApiResponse<Assignment[]>> => studentAPI.get("/", { params: { action: "get_class_assignments", ...params } })

export const getStudentClassSubjectsWithLessons = (params?): Promise<ApiResponse<SubjectStats[]>> => studentAPI.get("/", { params: { action: "get_class_lesson_stats", ...params } })
